module.exports = __webpack_public_path__ + "static/media/mt-icone-encart-4.bd451cb2.svg";